declare const COMPASS_REDIRECT_URL: string;
declare const GOOGLE_CLIENT_ID: string;
declare const GOOGLE_CLIENT_SECRET: string;

export const getTokensFromOAuthToken = async (googleOAuthToken: string) => {
  const response = await fetch('https://oauth2.googleapis.com/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      code: googleOAuthToken,
      client_id: GOOGLE_CLIENT_ID,
      client_secret: GOOGLE_CLIENT_SECRET,
      redirect_uri: COMPASS_REDIRECT_URL,
      grant_type: 'authorization_code'
    })
  });

  return await response.json();
};
